module.exports = __webpack_public_path__ + "static/media/error404.73f1eb11.svg";